import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UpdateOcrTradesAdditionsRequestModel, UpdateOcrTradesAdditionsResponseModel } from "@/features/accounts/ocr/services/update-trades-additions-model";

export class UpdateOcrTradesAdditionsApi {
  /**
   * OCR明細メモ・無効明細更新API
   */
  public updateOcrTradesAdditions = async (
    param: UpdateOcrTradesAdditionsRequestModel
  ): Promise<UpdateOcrTradesAdditionsResponseModel> => {
    const path = `/api/ocraccounts/trades`;
    const res = await ApiClient.instance.put<UpdateOcrTradesAdditionsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
